import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.14_db0@0.3.2_e_7b4b3ecf1c8dd06be30ffb8194ead0f5/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.14_db0@0.3.2_e_7b4b3ecf1c8dd06be30ffb8194ead0f5/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}